import { BasicModel } from "@goodgamestudios/core";
import { BasicCustomCursor } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";
import { Poker2Constants } from "../../constants/Poker2Constants";
import { SFConstants } from "../../constants/SFConstants";
import { Poker2DialogEvent } from "../../event/Poker2DialogEvent";
import { Poker2RankingDataEvent } from "../../event/Poker2RankingDataEvent";
import { Poker2UserEvent } from "../../event/Poker2UserEvent";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2CustomCombobox } from "../components/Poker2CustomCombobox";
import { Poker2MouseWheelUpDown } from "../components/Poker2MouseWheelUpDown";
import { Poker2AvatarCardDialogProperties } from "../dialogs/ranking/Poker2AvatarCardDialogProperties";
import { Poker2RankingDialogProperties } from "../dialogs/ranking/Poker2RankingDialogProperties";
import { Poker2Screen } from "./Poker2Screen";

import DisplayObject = createjs.DisplayObject;

import MouseEvent = createjs.MouseEvent;

export class Poker2RankingScreen extends Poker2Screen {
    public static NAME: string = "Poker2RankingScreen";

    public static STARTYEAR: number = 2011;
    public static STARTMONTH: number = 9;

    private currentView: number = 0;
    private mouseWheelUpDown: Poker2MouseWheelUpDown;

    private topPlayer: Poker2RankingTopPlayer;
    private tabRanking: Poker2RankingTabRanking;
    private tabTunier: Poker2RankingTabTunier;
    private tabHalloffame: Poker2RankingTabHalloffame;
    private selectedTab: number = 0;

    private X_POS: number = 133;
    private Y_POS: number = 296;

    constructor(disp: DisplayObject) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    public updatePosition(): void {
        if (this.disp && this.disp.stage) {
            this.disp.scaleX = this.disp.scaleY = this.layoutManager.scaleFactor;
            this.disp.x = ((800 / 2 + this.X_POS) * this.disp.scaleX) + this.layoutManager.gameNullPoint;
            this.disp.y = (this.Y_POS * this.layoutManager.scaleFactor);
        }
    }

    protected init(): void {
        super.init();
        this.controller.addEventListener("changeRankingTab", this.bindFunction(this.onChangeTab));
        this.mouseWheelUpDown = new Poker2MouseWheelUpDown();
        this.initComponents();
        this.rankingScreen.btn_close.visible = false;

        this.rankingScreen.bg.doCache(0, 2);
    }
    protected applyProperties(): void {
        this.topPlayer.applyProperties();
        this.tabRanking.applyProperties();
        this.tabTunier.applyProperties();
        this.tabHalloffame.applyProperties();
        this.changeMouseWheel();
    }
    private initComponents(): void {
        this.topPlayer = new Poker2RankingTopPlayer(this.rankingScreen.mc_topplayer);
        this.tabRanking = new Poker2RankingTabRanking(this.rankingScreen.mc_ranking);
        this.tabTunier = new Poker2RankingTabTunier(this.rankingScreen.mc_tunier);
        this.tabHalloffame = new Poker2RankingTabHalloffame(this.rankingScreen.mc_halloffame);

        this.rankingScreen.mc_topplayer.bg_back.addChild(new Library.PokerBackground.BG_Fame_Back());
        this.rankingScreen.mc_topplayer.bg_front.addChild(new Library.PokerBackground.BG_Fame_Front());
    }
    public show(): void {
        super.show();
        this.controller.addEventListener("changePlayerAvatar", this.bindFunction(this.onChangePlayerAvatar));

        this.topPlayer.show();
        this.tabRanking.show();
        this.tabTunier.show();
        this.tabHalloffame.show();
    }
    public hide(): void {
        super.hide();
        this.controller.addEventListener("changeRankingTab", this.bindFunction(this.onChangeTab));
        this.mouseWheelUpDown.deactivateMouseWheel();
        this.topPlayer.hide();
        this.tabRanking.hide();
        this.tabTunier.hide();
        this.tabHalloffame.hide();
        this.controller.removeEventListener("changePlayerAvatar", this.bindFunction(this.onChangePlayerAvatar));
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2RankingScreen" + "_" + 3, 0]));
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2RankingScreen" + "_" + 4, 0]));
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2RankingScreen" + "_" + 5, 0]));
    }

    private onChangeTab(event: Poker2RankingDataEvent): void {
        this.selectedTab = int(event.params[0]);
        this.changeTab(this.selectedTab);
    }

    public destroy(): void {
        super.destroy();
        this.mouseWheelUpDown.destroy();
    }

    private onChangePlayerAvatar(event: Poker2UserEvent): void {
        if (event.params[1] == 0) {
            this.layoutManager.showDialog("Poker2RankingAvatarDialog", new Poker2AvatarCardDialogProperties(event.params[0]));
        }
    }

    protected onCursorOver(event: MouseEvent): void {
        super.onCursorOver(event);
        if (instanceOfClass(event.target, "RankingCard") || instanceOfClass(event.target, "RankingPlayerCard"))
            this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_CLICK);
    }

    protected onClick(event: MouseEvent): void {
        if (event.target instanceof BasicButton && !event.target.enabled)
            return;

        super.onClick(event);

        switch (event.target.parent.name) {
            // case 'mc_topplayer':
            //     this.topPlayer.onClick(event);
            //     break;
            case 'mc_halloffame':
                this.tabHalloffame.onClick(event);
                break;
            case 'mc_ranking':
            case 'mc_list':
            case 'mc_avatarcards':
                this.tabRanking.onClick(event);
                switch (event.target) {
                    case this.rankingScreen.mc_ranking.cb_view:
                        this.changeMouseWheel();
                        break;
                }
                break;
            case 'mc_tunier':
                this.tabTunier.onClick(event);
                break;

            default:
                switch (event.target) {
                    case this.rankingScreen.btn_ranking:
                        this.changeTab(3);
                        break;
                    case this.rankingScreen.btn_turnier:
                        this.changeTab(4);
                        break;
                    case this.rankingScreen.btn_halloffame:
                        this.changeTab(5);
                        break;
                }
                break;
        }
    }

    protected onMouseOver(event: MouseEvent): void {
        if (instanceOfClass(event.target, "RankingLine")) {
            this.tabRanking.onMouseOver(event);
        }
        else if (instanceOfClass(event.target, "RankingTunierLine")) {
            this.tabTunier.onMouseOver(event);
        }
        else if (instanceOfClass(event.target, "RankingHallOffameLine")) {
            this.tabHalloffame.onMouseOver(event);
        }
        super.onMouseOver(event);
    }

    protected onMouseOut(event: MouseEvent): void {
        if (instanceOfClass(event.target, "RankingLine")) {
            this.tabRanking.onMouseOut(event);
        }
        else if (instanceOfClass(event.target, "RankingTunierLine")) {
            this.tabTunier.onMouseOut(event);
        }
        else if (instanceOfClass(event.target, "RankingHallOffameLine")) {
            this.tabHalloffame.onMouseOut(event);
        }
        super.onMouseOut(event);
    }
    private changeTab(tabIndex: number): void {
        this.currentView = tabIndex;
        this.rankingScreen.mc_ranking.visible = (tabIndex == 3);
        this.rankingScreen.mc_tunier.visible = (tabIndex == 4);
        this.rankingScreen.mc_halloffame.visible = (tabIndex == 5);
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2RankingScreen" + "_" + 3, (tabIndex == 3) ? 1 : 0]));
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2RankingScreen" + "_" + 4, (tabIndex == 4) ? 1 : 0]));
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2RankingScreen" + "_" + 5, (tabIndex == 5) ? 1 : 0]));

        switch (tabIndex) {
            case 3:
                this.tabRanking.changeTab();
                this.rankingScreen.btn_ranking.selected();
                this.rankingScreen.btn_turnier.deselected();
                this.rankingScreen.btn_halloffame.deselected();
                this.rankingScreen.btn_ranking.toolTipText = null;
                this.rankingScreen.btn_turnier.toolTipText = Poker2Model.languageData.getTextById("menu_btn_tunierranking");
                this.rankingScreen.btn_halloffame.toolTipText = Poker2Model.languageData.getTextById("menu_btn_halloffame");
                break;
            case 4:
                this.tabTunier.getListFromServer(-1);
                this.rankingScreen.btn_turnier.selected();
                this.rankingScreen.btn_ranking.deselected();
                this.rankingScreen.btn_halloffame.deselected();
                this.rankingScreen.btn_ranking.toolTipText = Poker2Model.languageData.getTextById("menu_btn_ranking");
                this.rankingScreen.btn_turnier.toolTipText = null;
                this.rankingScreen.btn_halloffame.toolTipText = Poker2Model.languageData.getTextById("menu_btn_halloffame");
                Poker2RankingScreen.setMonthComboBox(this.tabTunier.monthComboBox, this.tabTunier.yearComboBox);
                break;
            case 5:
                this.tabHalloffame.getListFromServer();
                this.rankingScreen.btn_halloffame.selected();
                this.rankingScreen.btn_ranking.deselected();
                this.rankingScreen.btn_turnier.deselected();
                this.rankingScreen.btn_ranking.toolTipText = Poker2Model.languageData.getTextById("menu_btn_ranking");
                this.rankingScreen.btn_turnier.toolTipText = Poker2Model.languageData.getTextById("menu_btn_tunierranking");
                this.rankingScreen.btn_halloffame.toolTipText = null;
                Poker2RankingScreen.setMonthComboBox(this.tabHalloffame.monthComboBox, this.tabHalloffame.yearComboBox);
                break;
        }
        this.changeMouseWheel();
    }

    private changeMouseWheel(): void {
        switch (this.currentView) {
            case 3:
                if (this.rankingScreen.mc_ranking.cb_view.isSelected) {
                    this.mouseWheelUpDown.init(this.rankingScreen.mc_ranking.mc_list.btn_up, this.rankingScreen.mc_ranking.mc_list.btn_down, this.rankingScreen.mc_ranking);
                } else {
                    this.mouseWheelUpDown.init(this.rankingScreen.mc_ranking.mc_avatarcards.btn_left, this.rankingScreen.mc_ranking.mc_avatarcards.btn_right, this.rankingScreen.mc_ranking);
                }
                break;
            case 4:
                this.mouseWheelUpDown.init(this.rankingScreen.mc_tunier.btn_up, this.rankingScreen.mc_tunier.btn_down, this.rankingScreen.mc_tunier);
                break;
            case 5:
                this.mouseWheelUpDown.init(this.rankingScreen.mc_halloffame.btn_up, this.rankingScreen.mc_halloffame.btn_down, this.rankingScreen.mc_halloffame);
                break;
        }
        this.mouseWheelUpDown.activateMouseWheel();
    }

    protected get rankingProperties(): Poker2RankingDialogProperties {
        return this.properties as Poker2RankingDialogProperties;
    }

    /**
     * @param monthComboBox
     * @param yearComboBox
     * @param defaultMonth
     * @param defaultYear
     */
    public static setMonthComboBox(monthComboBox: Poker2DynamicCombobox, yearComboBox: Poker2DynamicCombobox, defaultMonth: number = -1, defaultYear: number = -1): void {
        var currentDate: Date = new Date();
        var startMonth: number = 1;
        var stoppMonth: number = 12;
        var startYear: number = 2011;
        var stoppYear: number = int(currentDate.getFullYear());
        var i: number = 0;

        if (defaultYear == -1) {
            defaultYear = int(currentDate.getFullYear());
        }
        if (defaultYear == 2011) {
            startMonth = 9;
        }
        if (defaultYear == stoppYear) {
            stoppMonth = int(currentDate.getMonth() + 1);
        }
        if (defaultMonth == -1) {
            defaultMonth = int(currentDate.getMonth() + 1);
        }

        yearComboBox.clearItems();
        for (i = startYear; i <= stoppYear; i++) {
            yearComboBox.addItem({ label: i });
        }
        monthComboBox.clearItems();
        for (i = startMonth; i <= stoppMonth; i++) {
            monthComboBox.addItem({ label: Poker2Model.languageData.getTextById("dialog_ranking_month" + i) });
        }

        monthComboBox.defaultString = Poker2Model.languageData.getTextById("dialog_ranking_month" + defaultMonth);
        monthComboBox.selectItemIndex(defaultMonth - startMonth);
        yearComboBox.defaultString = String(defaultYear);
        yearComboBox.selectItemIndex(defaultYear - 2011);
    }

    public static getAvatarCard(playerId: number): void {
        var paramObject: any = { id: playerId, viewId: 0 };
        BasicModel.smartfoxClient.sendMessage("gpv", [JSON.stringify(paramObject)]);
    }

    public get rankingScreen(): Library.PokerInterface.PokerRanking {
        return this.disp as Library.PokerInterface.PokerRanking;
    }
}
import { Poker2RankingTabHalloffame } from "../components/ranking/Poker2RankingTabHalloffame";
import { Poker2RankingTabRanking } from "../components/ranking/Poker2RankingTabRanking";
import { Poker2RankingTabTunier } from "../components/ranking/Poker2RankingTabTunier";
import { Poker2RankingTopPlayer } from "../components/ranking/Poker2RankingTopPlayer";
import { Poker2AvatarCardDialog } from "../dialogs/ranking/Poker2AvatarCardDialog";
import { Poker2LayoutManager } from "../Poker2LayoutManager";

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
import { BasicButton } from "@goodgamestudios/poker2-createjs-assets";import { Poker2DynamicCombobox } from "../components/Poker2DynamicCombobox";

